<template>
	<div class="scly">
        <main>
            <div class="list">
                <h2 style="text-align:center">生产领用</h2>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="gongsi2"
                    label="油罐"
                    placeholder="点击选择油罐"
                    @click="showPicker1 = true"
                />

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="time"
                    label="领用时间"
                    placeholder="领用时间"
                    @click="showPicker3 = true"
                />

                <van-popup v-model:show="showPicker1" position="bottom">
                    <van-picker 
                        show-toolbar 
                        :columns="columns1" 
                        @confirm="onConfirm1"
                        @cancel="showPicker1 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker3" position="bottom">
                    <van-datetime-picker
                        :max-date="maxDate"
                        v-model="currentDate"
                        type="datetime"
                        @confirm="onConfirm3"
                        @cancel="showPicker3 = false"
                    />
                </van-popup>
               
                <van-field label="领用人" v-model="name" />

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="bumen"
                    label="领用部门"
                    placeholder="点击选择领用部门"
                    @click="showPicker2 = true"
                />

                <van-popup v-model:show="showPicker2" position="bottom">
                    <van-picker 
                        show-toolbar 
                        :columns="columns2" 
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                    />
                </van-popup>

                <van-field label="领用升数" v-model="shengshu" type="number" />
                <van-field label="备注" v-model="msg" />

                <div style="margin-left:16px">
                    <h4>油罐显示屏、加满后的加油容器水印照片</h4>
                    <van-uploader  v-model="fileList" multiple :max-count="3"  :before-read="beforeRead"/>
                </div>

                <van-button type="danger" style="width:100%;margin-top:40px" :disabled="disabled"  @click="sub()">提交</van-button>
            </div>
        </main>
    </div>
</template>

<script>
    import { url2} from '../router/api';
    import option from "../config/option.js"

	export default{
		data(){
			return{
                showPicker1:false,
                showPicker2:false,
                disabled:false,
                columns1:[],
                columns2:option.bumen,
                gongsi2:'',
                name:'',
                bumen:'',
                shengshu:'',
                msg:'',
                fileList:[],

                time:'',
                showPicker3:false,
                currentDate: new Date(),
                maxDate: new Date(),
            }
        },
        mounted() {
            const elementToRemove = '全部';
            const elementToRemove2 = '场外加油站';
            var flag = option.you.filter(item => item !== elementToRemove);
            this.columns1 = flag.filter(item => item !== elementToRemove2);
        },
		methods: {
            sub() {
                // console.log(this.time)
                if(this.gongsi2=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择加油油罐',
                    }).then(() => {
                        return;
                    });
                } else if(this.time=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择领用时间',
                    }).then(() => {
                        return;
                    });
                } else if(this.name=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写领用人',
                    }).then(() => {
                        return;
                    });
                } else if(this.bumen=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写部门',
                    }).then(() => {
                        return;
                    });
                } else if(this.shengshu=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写升数',
                    }).then(() => {
                        return;
                    });
                } else if(this.fileList=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传照片',
                    }).then(() => {
                        return;
                    });
                } else if(this.fileList.length<2) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请最少上传两张照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: '加载中',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var formData =new FormData();
                    this.fileList.map(item=>{
                        formData.append('file[]',item.file);
                    })
                    this.axios.post(url2+'upload4',(formData),{
                        headers: {  'Content-Type': 'multipart/form-data;' }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.sure2(res.data.data)
                        }  else {
                            this.loading.close();
                        }
                    }).catch(err=> {
                        this.loading.close();
                        console.log(err);
                    });
                }
            },

            sure2(photo) {
                this.axios.get(url2+'scly', {
                    params:{
                        gongsi2:this.gongsi2,
                        name:this.name,
                        bumen:this.bumen,
                        shengshu:this.shengshu,
                        mess:this.msg,
                        time:this.time,
                        url:photo.toString(),
                    }
                }).then(res=> {
                    if(res.status==200) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            this.disabled = true
                        });
                    } else {
                        this.loading.close();
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },

            onConfirm1(value) {
                this.gongsi2 = value
                this.showPicker1 = false;
            },
            onConfirm2(value) {
                this.bumen = value
                this.showPicker2 = false;
            },
            beforeRead(file){
                return this.$compress(file)
            },

            onConfirm3(value) {
                this.time = this.formatDate(value)
                this.showPicker3 = false;
            },

            formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                let hh = date.getHours()
                let mm = date.getMinutes()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                hh = hh < 10 ? '0' + hh : hh
                mm = mm < 10 ? '0' + mm : mm
                return `${y}-${m}-${d} ${hh}:${mm}`;
            },
        }
    }
</script>

<style scoped="scoped" lang='less'>
    .scly main {
        font-size: 14px;
        padding: 40px 16px 300px 16px;
        background-color: #FFDCA3;
    }
    .scly .list {
        background-color: #fff;
        padding: 20px 20px 80px 20px;
    }
</style>